import '@nobleclem/jquery-multiselect/jquery.multiselect.js';
import '@nobleclem/jquery-multiselect/jquery.multiselect.css';

$('select[multiple]').multiselect({
    texts: {
        placeholder: 'Seleziona destinazioni (max 3)',
    },
    onOptionClick: function( element, option ) {
        const maxSelect = 3;

        // too many selected, deselect this option
        if( $(element).val().length > maxSelect ) {
            if( $(option).is(':checked') ) {
                const thisVals = $(element).val();

                thisVals.splice(thisVals.indexOf( $(option).val() ), 1);
                $(element).val(thisVals);

                $(option).prop( 'checked', false ).closest('li').toggleClass('selected');
            }
        }
        // max select reached, disable non-checked checkboxes
        else if( $(element).val().length == maxSelect ) {
            $(element).next('.ms-options-wrap')
                .find('li:not(.selected)').addClass('disabled')
                .find('input[type="checkbox"]')
                    .attr( 'disabled', 'disabled' );
        }
        // max select not reached, make sure any disabled
        // checkboxes are available
        else {
            $(element).next('.ms-options-wrap')
                .find('li.disabled').removeClass('disabled')
                .find('input[type="checkbox"]')
                    .removeAttr( 'disabled' );
        }
    }
});
